"use client"

import Login from "@/Components/SignUp/Login/Login";
import React, { useEffect } from "react";
import Cookies from "js-cookie";

const page = () => {

  // useEffect(() => {
  //   // Cookies.set("token", clinicData?.data?.token)
  //   Cookies.remove("token")
  //   Cookies.remove("id")
  //     // Cookies.set("id", clinicData?.data?.reps)
  // }, [])
  

  return (
    <div>
      <Login />
    </div>
  );
};

export default page;
